import { Box, styled } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const EmptyStateWrapper = styled(Box)(() => ({
  display: "flex",
  width: "100%",
  flexDirection: "column",
  alignItems: "center",
  padding: pxToRem(48),
  borderRadius: pxToRem(10),
}));
